<template>
  <div class="bottom-bar bg-darkgrey">
    <div class="bottom-bar__left">
      <span class="bottom-bar__version">v{{ version }}</span>
      <div class="bottom-bar__batch-wrap" id="batch-button-anchor"></div>
    </div>
    <div class="bottom-bar__right">
      <ticket-button />
      <div class="bottom-bar__chat-wrap">
        <ChatPage :firebase="firebaseUtil" />
      </div>
    </div>
  </div>
</template>

<script>
import TicketButton from './TicketButton.vue'
import { ChatPage } from '@keepneye/kne-chat'
import * as firebaseUtil from '../../../firebase.js'

export default {
  name: 'BottomBar',
  components: {
    TicketButton,
    ChatPage
  },
  data () {
    return {
      firebaseUtil,
      version: '5.1.0'
    }
  },
  mounted () {
    this.repositionBatchButton()
  },
  methods: {
    repositionBatchButton () {
      const anchor = document.getElementById('batch-button-anchor')
      if (!anchor) return
      const checkBatch = setInterval(() => {
        const batchBtn = document.getElementById('batchsdk-ui-button')
        if (batchBtn && batchBtn.parentElement) {
          clearInterval(checkBatch)
          anchor.appendChild(batchBtn.parentElement)
        }
      }, 500)
      setTimeout(() => clearInterval(checkBatch), 10000)
    }
  }
}
</script>

<style>
.bottom-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2rem;
  z-index: 1028;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.75rem;
  border-top: 1px solid rgba(247, 148, 30, 0.3);
}

.bottom-bar__left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bottom-bar__right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bottom-bar__version {
  font-size: 0.7rem;
  color: rgba(255, 255, 255, 0.35);
  letter-spacing: 0.5px;
  padding-right: 0.75rem;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
  margin-right: 0.75rem;
  line-height: 2rem;
}

.bottom-bar__batch-wrap {
  display: inline-flex;
  align-items: center;
}

.bottom-bar__batch-wrap > * {
  position: relative !important;
  bottom: auto !important;
  left: auto !important;
  top: auto !important;
  right: auto !important;
  display: inline-flex !important;
  align-items: center !important;
}

#batchsdk-ui-button {
  position: relative !important;
  bottom: auto !important;
  left: auto !important;
  top: auto !important;
  right: auto !important;
  width: 1.6rem !important;
  height: 1.6rem !important;
  min-width: unset !important;
  min-height: unset !important;
  border-radius: 4px !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  margin: 0 !important;
  background-color: #2c2d2f !important;
}

#batchsdk-ui-button svg {
  width: 14px !important;
  height: 14px !important;
}

#batchsdk-ui-button__tooltip {
  display: none !important;
}


.bottom-bar__chat-wrap {
  display: inline-flex;
  align-items: center;
}

.bottom-bar__chat-wrap .hasNoMessageBtn,
.bottom-bar__chat-wrap .hasMessageBtn {
  position: relative !important;
  right: auto !important;
  bottom: auto !important;
  width: 1.6rem !important;
  height: 1.6rem !important;
  font-size: 0.85rem !important;
  border-radius: 4px !important;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: auto !important;
}

.bottom-bar__chat-wrap .messageColumn {
  position: fixed !important;
  bottom: 2rem !important;
  left: 3rem !important;
  right: auto !important;
}

.bottom-bar__chat-wrap .chatContainer {
  margin-bottom: 2rem !important;
}
</style>
